import React, { Component } from 'react';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { mergeStyleSets } from 'office-ui-fabric-react';

import { DataIndicateur } from '../../data/DataIndicateur.jsx';

import { Immocom } from '../../specifique/immocom';

//#region CSS
const classNames = mergeStyleSets({
    modalContainer: {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '60vh',
        maxWidth: '500px',
        width: '60vw'
    },
    modalHeader: {
        background: '#fd0400',
        color: 'white',
        padding: '8px 28px 0'
    },
    modalBody: {
        flex: '2 2',
        overflowY: 'auto',
        padding: '5px 28px'
    },
    modalFooter: {
        display: 'flex',
        justifyContent: 'center',
        padding: '15px 28px',
    }
});
//#endregion

export class ModalIndicateur extends Component {
    constructor(props) {
        super(props);

        this.state = {
            onAfficheModalIndicateur: false,
            compteurModifie: ""  
        }
    };

    componentDidMount = () => {
        let chargementIndicateurEnDecalage = DataIndicateur._chargementListeDesIndicateursEnDecalage();

        chargementIndicateurEnDecalage
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    const objetData = responseFetch.reponseAPIobjet;

                    if (objetData && objetData.length > 0) {
                        var compteurModifie = "";
                        objetData.forEach(o => {
                            if (o.provenance == 'Indicateurs')
                                compteurModifie += (compteurModifie != '' ? ' - ' : '') + o.compteur
                        });
                        if (compteurModifie != "") {
                            this.setState({
                                onAfficheModalIndicateur: true,
                                compteurModifie: compteurModifie
                            });
                        }
                    }
                }
            });
    };

    render = () => {
        return <Modal
            isOpen={this.state.onAfficheModalIndicateur}
            onDismiss={() => this.setState({ onAfficheModalIndicateur: false })}
            containerClassName={classNames.modalContainer}
        >
            <div className={classNames.modalHeader}>
                <h3>Contrôle Indicateurs</h3>
            </div>
            <div className={classNames.modalBody}>
                <Icon iconName="Warning" /> Les indicateurs ({this.state.compteurModifie}) ont été modifié.
            </div>
            <div className={classNames.modalFooter}>
                <DefaultButton onClick={() => this.setState({ onAfficheModalIndicateur: false })} text="Fermer" />
            </div>
        </Modal>
    };
}